import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const DEFAULT_ADVANCED_OPTIONS_SURVEY = {
  randomize_groups: null,
}

export const surveyAdvancedOptionsToRenderConfig = {
  auto_select_when_inheriting_one: {
    type: 'boolean',

    displayText: {
      [PORTUGUESE]: 'Auto Selecionar em Questões Que Herdam Apenas uma opção:',
      [ENGLISH]: 'Auto Select Questions if inheritance finds only one option:',
      [SPANISH]: 'Auto Selecionar em Questões Que Herdam Apenas uma opção:',
    },

    treatedIndividually: false,

    required: false,

    disableChecker: survey =>
      !survey.questions_groups.some(({ questions }) =>
        questions.some(({ advancedOptions }) => {
          const validOptions = [
            'advanced_inheritance',
            'array_filter',
            'array_filter_reverse',
          ]

          return validOptions.some(option => advancedOptions[option])
        }),
      ),
  },

  randomize_groups: {
    type: 'boolean',

    displayText: {
      [PORTUGUESE]: 'Randomizar Grupos:',
      [ENGLISH]: 'Randomize Groups:',
      [SPANISH]: 'Grupos Aleatorios:',
    },

    treatedIndividually: false,

    required: false,

    disableChecker: survey => !!survey.advancedOptions?.randomize_by_tags,

    toggleAction: {
      onEnable: {
        confirmationModal: true,

        updater: questionGroups => {
          const updatedGroups = (questionGroups || []).map(
            ({ logic: __, ...group }) => group,
          )

          return updatedGroups
        },

        modalText: {
          [PORTUGUESE]:
            'Randomizar os grupos <strong>excluirá a lógica de todos os grupos</strong> da pesquisa. Tem certeza?',
          [ENGLISH]:
            'Enabling group randomization will <strong>exclude the logic of all groups</strong> from the survey. Are you sure?',
          [SPANISH]:
            'Aleatorizar los grupos <strong>excluirá la lógica de todos los grupos</strong> de la encuesta. ¿Está seguro?',
        },
      },

      onDisable: {
        confirmationModal: false,
      },
    },
  },

  randomize_by_tags: {
    type: 'boolean',

    hasCustomRenderer: true,

    uncheckedValue: null,

    displayText: {
      [PORTUGUESE]: 'Randomizar Grupos por tags:',
      [ENGLISH]: 'Randomize Groups by tags:',
      [SPANISH]: 'Grupos Aleatorios por tags:',
    },

    disableChecker: survey => !!survey.advancedOptions?.randomize_groups,

    treatedIndividually: false,
    required: false,

    toggleAction: {
      onEnable: {
        confirmationModal: true,

        updater: questionGroups => {
          const updatedGroups = (questionGroups || []).map(
            ({ logic: __, ...group }) => group,
          )

          return updatedGroups
        },

        modalText: {
          [PORTUGUESE]:
            'Randomizar os grupos <strong>excluirá a lógica de todos os grupos</strong> da pesquisa. Tem certeza?',
          [ENGLISH]:
            'Enabling group randomization will <strong>exclude the logic of all groups</strong> from the survey. Are you sure?',
          [SPANISH]:
            'Aleatorizar los grupos <strong>excluirá la lógica de todos los grupos</strong> de la encuesta. ¿Está seguro?',
        },
      },

      onDisable: {
        confirmationModal: false,
      },
    },
  },
}
